export default {"src":"/_next/static/media/person_outline.fac0fd37.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};